import { apiSlice } from './apiSlice';

export interface AshtakvargaData {
  imageUrl: string;
  data: any;
}

export interface AshtakvargaResponse {
  sarvashtak: AshtakvargaData;
  ascendant: AshtakvargaData;
  sun: AshtakvargaData;
  moon: AshtakvargaData;
  mars: AshtakvargaData;
  mercury: AshtakvargaData;
  jupiter: AshtakvargaData;
  venus: AshtakvargaData;
  saturn: AshtakvargaData;
}

export const ashtakvargaApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAshtakvarga: builder.query<AshtakvargaResponse, { userId: string }>({
      query: ({ userId }) => ({
        url: '/astrology/astakvarga',
        method: 'POST',
        body: { userId },
      }),
    }),
  }),
});

export const { useGetAshtakvargaQuery } = ashtakvargaApi;
